import { z } from 'zod';

export const trainingRequestSchema = z.object({
    fullname: z.string().min(1, 'required'),
    phone: z.string(), 
    organisation: z.string()
        .optional()
        .refine((arg) => {
            const element = document.getElementById('organisation') as HTMLInputElement;
            if (!element || element.value.length > 0) {
                return true;
            }
            
            return false;
        }, { message: "required"}),
    country: z.string().min(1, 'required'),
    email: z.string().min(1, 'required'),
    street: z.string().optional(),
    postcode: z.string().optional(),
    city: z.string().optional(),
    vat: z.string().optional(),
    IsAccepted: z.string()
        .refine((arg) => {
            if (arg == "true") {
                return true;
            }
            return false
        }, 
        { message: "Please accepted terms and conditions" })
});